import {Component} from '@angular/core';

@Component({
    selector: 'nirby-settings-layout',
    templateUrl: './settings-layout.component.html',
    styleUrls: ['./settings-layout.component.scss'],
})
export class SettingsLayoutComponent {
}
